// AUTO-GENERATED by `npm run curate`. Do not hand-edit - the curation CLI rewrites
// this file when a chapter is approved (or reverted).
//
// This map overrides the per-chapter `curated` / `needsReview` flags consumed by
// `index.ts`. Listing a chapter as "curated" here is what flips the library card
// from "PDF-extracted · awaiting review" to "Curated".

export type CurationStatus = "curated" | "pdf-extracted";

export interface CurationStatusEntry {
  status: CurationStatus;
  approvedAt?: string;
  reviewer?: string;
}

export const CURATION_STATUS_SCHEMA_VERSION = 1;

export const CURATION_STATUS: Record<string, CurationStatusEntry> = {
  "01": { status: "curated", approvedAt: "2026-05-21T00:00:00Z" },
  "02": { status: "curated", approvedAt: "2026-05-21T01:00:00Z" },
  "03": { status: "curated", approvedAt: "2026-05-21T01:00:00Z" },
  "04": { status: "curated", approvedAt: "2026-05-21T01:00:00Z" },
  "05": { status: "curated", approvedAt: "2026-05-21T01:00:00Z" },
  "06": { status: "curated", approvedAt: "2026-05-21T01:30:00Z" },
  "07": { status: "curated", approvedAt: "2026-05-21T01:30:00Z" },
  "08": { status: "curated", approvedAt: "2026-05-21T01:30:00Z" },
  "09": { status: "curated", approvedAt: "2026-05-21T01:30:00Z" },
  "10": { status: "curated", approvedAt: "2026-05-21T01:30:00Z" },
  "11": { status: "curated", approvedAt: "2026-05-21T02:00:00Z" },
  "12": { status: "curated", approvedAt: "2026-05-21T02:00:00Z" },
  "13": { status: "curated", approvedAt: "2026-05-21T02:00:00Z" },
  "14": { status: "curated", approvedAt: "2026-05-21T02:00:00Z" },
  "15": { status: "curated", approvedAt: "2026-05-21T02:00:00Z" },
  "16": { status: "curated", approvedAt: "2026-05-21T02:30:00Z" },
  "17": { status: "curated", approvedAt: "2026-05-21T02:30:00Z" },
  "18": { status: "curated", approvedAt: "2026-05-21T02:30:00Z" },
  "19": { status: "curated", approvedAt: "2026-05-21T02:30:00Z" },
  "20": { status: "curated", approvedAt: "2026-05-21T02:30:00Z" },
  "21": { status: "curated", approvedAt: "2026-05-21T03:00:00Z" },
  "22": { status: "curated", approvedAt: "2026-05-21T03:00:00Z" },
  "23": { status: "curated", approvedAt: "2026-05-21T03:00:00Z" },
  "24": { status: "curated", approvedAt: "2026-05-21T03:00:00Z" },
  "25": { status: "curated", approvedAt: "2026-05-21T03:00:00Z" },
  "26": { status: "curated", approvedAt: "2026-05-21T03:30:00Z" },
  "27": { status: "curated", approvedAt: "2026-05-21T03:30:00Z" },
  "28": { status: "curated", approvedAt: "2026-05-21T03:30:00Z" },
  "29": { status: "curated", approvedAt: "2026-05-21T03:30:00Z" },
  "30": { status: "curated", approvedAt: "2026-05-21T03:30:00Z" },
  "31": { status: "curated", approvedAt: "2026-05-21T03:30:00Z" },
};
